import algoliasearch from 'algoliasearch/lite';
import React, { useState } from 'react';
import TabContainer from './TabContainer';
import {
  InstantSearch,
  Hits,
  Pagination,
  Configure,
  connectSearchBox,
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import './App.css';
import Autocomplete from './AutoComplete';
const searchClient = algoliasearch(
  'FTVTL5CJ9D',
  '2a422465fc0c882acd6aa2c1c53ee642'
);

function App() {
  const [state, setState] = useState({ query: '' });
  const VirtalSearchBox = connectSearchBox(() => null);

  return (
    <div className="ais-InstantSearch">
      <h1 style={{ textAlign: 'center', fontFamily: 'FrankRuhlLibre' }}>
        Customer Support
      </h1>
      <InstantSearch indexName="test1" searchClient={searchClient}>
        <Configure hitsPerPage={5} />
        <Autocomplete
        
          onSuggestionSelected={(_, { suggestion }) => {
            setState({
              query: suggestion['How do I cancel my order?'],//modify
            });
          }}
          onSuggestionCleared={() => {
            setState({
              query: '',
            });
          }}
        />
      </InstantSearch>

      <InstantSearch indexName="test1" searchClient={searchClient}>
        <TabContainer />
        <div className="listContainer">
          <List title="a" />
          <List title="a" />
          <List title="a" />
          <List title="a" />
          <List title="a" />
          <List title="a" />
        </div>
        <div className="boxContainer">
          <div className="box">lorem ipsum</div>
          <div className="box">lorem ipsum</div>
          <div className="box">lorem ipsum</div>
        </div>
        <Hits hitComponent={Hit} />
        <VirtalSearchBox defaultRefinement={state.query} />
        <Pagination />
        <Configure hitsPerPage={4} />
      </InstantSearch>
    </div>
  );
}

function List(props) {
  return (
    <div className="list">
      <h1>{props.title}</h1>
      <p>q1 lorem ipsum</p>
      <p>q2 lorem ipsum</p>
      <p>q3 lorem ipsum</p>
    </div>
  );
}

function Hit(props) {
  return (
    <div>
      <div>{props.hit['How do I cancel my order?']}</div>
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx